import _regeneratorRuntime from "@babel/runtime/regenerator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module remove-format/removeformatcommand
 */
import { Command } from 'ckeditor5/src/core';
import { first } from 'ckeditor5/src/utils';
/**
 * The remove format command.
 *
 * It is used by the {@link module:remove-format/removeformat~RemoveFormat remove format feature}
 * to clear the formatting in the selection.
 *
 *		editor.execute( 'removeFormat' );
 *
 * @extends module:core/command~Command
 */

var RemoveFormatCommand =
/*#__PURE__*/
function (_Command) {
  _inherits(RemoveFormatCommand, _Command);

  function RemoveFormatCommand() {
    _classCallCheck(this, RemoveFormatCommand);

    return _possibleConstructorReturn(this, _getPrototypeOf(RemoveFormatCommand).apply(this, arguments));
  }

  _createClass(RemoveFormatCommand, [{
    key: "refresh",

    /**
     * @inheritDoc
     */
    value: function refresh() {
      var model = this.editor.model;
      this.isEnabled = !!first(this._getFormattingItems(model.document.selection, model.schema));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "execute",
    value: function execute() {
      var _this = this;

      var model = this.editor.model;
      var schema = model.schema;
      model.change(function (writer) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = _this._getFormattingItems(model.document.selection, schema)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var item = _step.value;

            if (item.is('selection')) {
              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = _this._getFormattingAttributes(item, schema)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var attributeName = _step2.value;
                  writer.removeSelectionAttribute(attributeName);
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
                    _iterator2["return"]();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }
            } else {
              // Workaround for items with multiple removable attributes. See
              // https://github.com/ckeditor/ckeditor5-remove-format/pull/1#pullrequestreview-220515609
              var itemRange = writer.createRangeOn(item);
              var _iteratorNormalCompletion3 = true;
              var _didIteratorError3 = false;
              var _iteratorError3 = undefined;

              try {
                for (var _iterator3 = _this._getFormattingAttributes(item, schema)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                  var _attributeName = _step3.value;
                  writer.removeAttribute(_attributeName, itemRange);
                }
              } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion3 && _iterator3["return"] != null) {
                    _iterator3["return"]();
                  }
                } finally {
                  if (_didIteratorError3) {
                    throw _iteratorError3;
                  }
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
              _iterator["return"]();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      });
    }
    /**
     * Returns an iterable of items in a selection (including the selection itself) that have formatting model
     * attributes to be removed by the feature.
     *
     * @protected
     * @param {module:engine/model/documentselection~DocumentSelection} selection
     * @param {module:engine/model/schema~Schema} schema The schema describing the item.
     * @returns {Iterable.<module:engine/model/item~Item>|Iterable.<module:engine/model/documentselection~DocumentSelection>}
     */

  }, {
    key: "_getFormattingItems",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _getFormattingItems(selection, schema) {
      var _this2 = this;

      var itemHasRemovableFormatting, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, curRange, _iteratorNormalCompletion6, _didIteratorError6, _iteratorError6, _iterator6, _step6, item, _iteratorNormalCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, block;

      return _regeneratorRuntime.wrap(function _getFormattingItems$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              itemHasRemovableFormatting = function itemHasRemovableFormatting(item) {
                return !!first(_this2._getFormattingAttributes(item, schema));
              }; // Check formatting on selected items that are not blocks.


              _iteratorNormalCompletion4 = true;
              _didIteratorError4 = false;
              _iteratorError4 = undefined;
              _context.prev = 4;
              _iterator4 = selection.getRanges()[Symbol.iterator]();

            case 6:
              if (_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done) {
                _context.next = 38;
                break;
              }

              curRange = _step4.value;
              _iteratorNormalCompletion6 = true;
              _didIteratorError6 = false;
              _iteratorError6 = undefined;
              _context.prev = 11;
              _iterator6 = curRange.getItems()[Symbol.iterator]();

            case 13:
              if (_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done) {
                _context.next = 21;
                break;
              }

              item = _step6.value;

              if (!(!schema.isBlock(item) && itemHasRemovableFormatting(item))) {
                _context.next = 18;
                break;
              }

              _context.next = 18;
              return item;

            case 18:
              _iteratorNormalCompletion6 = true;
              _context.next = 13;
              break;

            case 21:
              _context.next = 27;
              break;

            case 23:
              _context.prev = 23;
              _context.t0 = _context["catch"](11);
              _didIteratorError6 = true;
              _iteratorError6 = _context.t0;

            case 27:
              _context.prev = 27;
              _context.prev = 28;

              if (!_iteratorNormalCompletion6 && _iterator6["return"] != null) {
                _iterator6["return"]();
              }

            case 30:
              _context.prev = 30;

              if (!_didIteratorError6) {
                _context.next = 33;
                break;
              }

              throw _iteratorError6;

            case 33:
              return _context.finish(30);

            case 34:
              return _context.finish(27);

            case 35:
              _iteratorNormalCompletion4 = true;
              _context.next = 6;
              break;

            case 38:
              _context.next = 44;
              break;

            case 40:
              _context.prev = 40;
              _context.t1 = _context["catch"](4);
              _didIteratorError4 = true;
              _iteratorError4 = _context.t1;

            case 44:
              _context.prev = 44;
              _context.prev = 45;

              if (!_iteratorNormalCompletion4 && _iterator4["return"] != null) {
                _iterator4["return"]();
              }

            case 47:
              _context.prev = 47;

              if (!_didIteratorError4) {
                _context.next = 50;
                break;
              }

              throw _iteratorError4;

            case 50:
              return _context.finish(47);

            case 51:
              return _context.finish(44);

            case 52:
              // Check formatting from selected blocks.
              _iteratorNormalCompletion5 = true;
              _didIteratorError5 = false;
              _iteratorError5 = undefined;
              _context.prev = 55;
              _iterator5 = selection.getSelectedBlocks()[Symbol.iterator]();

            case 57:
              if (_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done) {
                _context.next = 65;
                break;
              }

              block = _step5.value;

              if (!itemHasRemovableFormatting(block)) {
                _context.next = 62;
                break;
              }

              _context.next = 62;
              return block;

            case 62:
              _iteratorNormalCompletion5 = true;
              _context.next = 57;
              break;

            case 65:
              _context.next = 71;
              break;

            case 67:
              _context.prev = 67;
              _context.t2 = _context["catch"](55);
              _didIteratorError5 = true;
              _iteratorError5 = _context.t2;

            case 71:
              _context.prev = 71;
              _context.prev = 72;

              if (!_iteratorNormalCompletion5 && _iterator5["return"] != null) {
                _iterator5["return"]();
              }

            case 74:
              _context.prev = 74;

              if (!_didIteratorError5) {
                _context.next = 77;
                break;
              }

              throw _iteratorError5;

            case 77:
              return _context.finish(74);

            case 78:
              return _context.finish(71);

            case 79:
              if (!itemHasRemovableFormatting(selection)) {
                _context.next = 82;
                break;
              }

              _context.next = 82;
              return selection;

            case 82:
            case "end":
              return _context.stop();
          }
        }
      }, _getFormattingItems, null, [[4, 40, 44, 52], [11, 23, 27, 35], [28,, 30, 34], [45,, 47, 51], [55, 67, 71, 79], [72,, 74, 78]]);
    })
    /**
     * Returns an iterable of formatting attributes of a given model item.
     *
     * **Note:** Formatting items have the `isFormatting` property set to `true`.
     *
     * @protected
     * @param {module:engine/model/item~Item|module:engine/model/documentselection~DocumentSelection} item
     * @param {module:engine/model/schema~Schema} schema The schema describing the item.
     * @returns {Iterable.<String>} The names of formatting attributes found in a given item.
     */

  }, {
    key: "_getFormattingAttributes",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _getFormattingAttributes(item, schema) {
      var _iteratorNormalCompletion7, _didIteratorError7, _iteratorError7, _iterator7, _step7, _ref3, _ref2, attributeName, attributeProperties;

      return _regeneratorRuntime.wrap(function _getFormattingAttributes$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _iteratorNormalCompletion7 = true;
              _didIteratorError7 = false;
              _iteratorError7 = undefined;
              _context2.prev = 3;
              _iterator7 = item.getAttributes()[Symbol.iterator]();

            case 5:
              if (_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done) {
                _context2.next = 16;
                break;
              }

              _ref3 = _step7.value;
              _ref2 = _slicedToArray(_ref3, 1);
              attributeName = _ref2[0];
              attributeProperties = schema.getAttributeProperties(attributeName);

              if (!(attributeProperties && attributeProperties.isFormatting)) {
                _context2.next = 13;
                break;
              }

              _context2.next = 13;
              return attributeName;

            case 13:
              _iteratorNormalCompletion7 = true;
              _context2.next = 5;
              break;

            case 16:
              _context2.next = 22;
              break;

            case 18:
              _context2.prev = 18;
              _context2.t0 = _context2["catch"](3);
              _didIteratorError7 = true;
              _iteratorError7 = _context2.t0;

            case 22:
              _context2.prev = 22;
              _context2.prev = 23;

              if (!_iteratorNormalCompletion7 && _iterator7["return"] != null) {
                _iterator7["return"]();
              }

            case 25:
              _context2.prev = 25;

              if (!_didIteratorError7) {
                _context2.next = 28;
                break;
              }

              throw _iteratorError7;

            case 28:
              return _context2.finish(25);

            case 29:
              return _context2.finish(22);

            case 30:
            case "end":
              return _context2.stop();
          }
        }
      }, _getFormattingAttributes, null, [[3, 18, 22, 30], [23,, 25, 29]]);
    })
  }]);

  return RemoveFormatCommand;
}(Command);

export { RemoveFormatCommand as default };